import React, { useEffect, useState} from 'react';
import checkSeveral from '../icons/CheckSeveral.svg'
import Down from '../icons/Down.svg'
import ResultComponent from '../results/ResultComponent';
import Modal from '../Modal';
import AddVideoToPlaylistContent from '../playlistAdds/AddVideoToPlaylistContent';
import useWindowDimentions from '../hooks/useWindowDimentions';
import { useSelector } from 'react-redux';
import { useNavigationType } from 'react-router-dom';
import { formatSeconds } from '../../utils/formatTime'



const ResultsComponent = (props) => {

    const [checkActive, setCheckActive] = useState(false)

    const [selected, setSelected] = useState(false)

    const [addActive, setAddActive] = useState(false)

    const [chosenDuration, setChosenDuration] = useState(0)

    const [right, setRight] = useState(0)

    const {width, height} = useWindowDimentions()

    const [top, setTop] = useState(0)

    const { user } = useSelector(state=>state.user)

    const navigationType = useNavigationType();


    const selectAllHandler = () => {
        setCheckActive(true)
        if(selected){
            props.setVideoList([])
            setChosenDuration(0)
        } else {
            props.setVideoList(props.filterResults.map(i=>i.id))
            setChosenDuration(props.filterResults.reduce((sum, item)=>sum+item.duration, 0))
        }
        setSelected(!selected)
    }

    const addClickHandler = (e) => {
        if (e.clientX < 450){
            setRight(30)
        } else {
            setRight(width-e.clientX+5)
        }
        setTop(e.clientY)
        setAddActive(true)
    }


    useEffect(()=>{
        setCheckActive(false)
        if (navigationType === "POP") {
            const savedScroll = sessionStorage.getItem("results-scroll");
            if (props.resultRef.current && savedScroll !== null) {
            props.resultRef.current.scrollTo({
                top: parseInt(savedScroll, 10),
                behavior: "auto", // or 'smooth' if you want animation
            });
            }
        }
    },[props.data, navigationType])

    return (
        <>
            {
                props.filterResults && props.filterResults.length ?
                <div className = "w-100 d-flex flex-column align-items-start"
                    >
                    <div className = "w-100 d-flex flex-column align-items-start pb-5">
                        <div className='w-100 top-0 d-flex justify-content-start'>
                            <div className='col-11 py-2 d-flex flex-column flex-md-row justify-content-between '>
                                <div className = "text-info pt-2 fs-4">RESULTS</div>
                                <div className='d-flex align-items-center flex-column flex-md-row py-2'>
                                    <div className='d-flex align-items-start py-2 py-md-0'>
                                        {
                                            checkActive && props.videoList && props.videoList.length ?
                                            <>
                                                <div className = "text-info px-3 text-nowrap">{props.videoList.length} Videos</div>
                                                <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(chosenDuration)} </div>

                                            </> :
                                            props.info && props.info.count?
                                            <>
                                                <div className = "text-info px-3 text-nowrap">{props.info.count} Videos</div>
                                                <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(props.info.duration)} </div>

                                            </>: ""
                                        }
                                    </div>
                                    {
                                        user && user.first_name ?
                                            <div className='d-flex align-items-center' style={{gap:"1rem"}}>
                                        {
                                            checkActive ?
                                            <>
                                                <div
                                                    role = "button"
                                                    className='rounded px-3 py-1 d-flex'
                                                    style={props.videoList && props.videoList.length ? {background:"#FFCD00", gap:"0.5rem"} :{background:"#708090", gap:"0.5rem"}}
                                                    onClick={props.videoList && props.videoList.length ? (e)=>addClickHandler(e): ()=>{alert('please, choose a video')}}
                                                    >
                                                    <div>Add to</div>
                                                    <img src={Down}
                                                    alt=''
                                                    />
                                                </div>
                                                <div
                                                    style={{color:"#FFCD00"}}
                                                    role='button'
                                                    onClick={()=>{setCheckActive(false); props.setVideoList([]); setChosenDuration(0)}}>Exit</div>
                                                </>:
                                            <button
                                                className='rounded px-4 py-1'
                                                style={{background:"#FFCD00"}}
                                                onClick={()=>setCheckActive(!checkActive)}
                                                >Select</button>
                                        }
                                        <div className='d-flex'
                                            role='button'
                                            onClick = {()=>selectAllHandler()}>
                                            <div
                                                style={{color:"#FFCD00"}}
                                                >All</div>
                                            <img
                                                className='px-1'
                                                alt = ''
                                                src = {checkSeveral} />
                                        </div>
                                    </div> : ''
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-12 px-0 pt-4 d-flex flex-row flex-wrap'
                                style={{height: height - 200 + "px"}}
                            ref={props.resultRef}
                            onScroll = {props.handleScroll}
                            >
                            {
                                props.filterResults.map((result, index) => (
                                    <div key = {index}
                                        className = {props.videoList.includes(result.id) ?
                                            "col-6 col-md-4 col-lg-3 px-1 py-2 d-flex align-items-start bg-secondary border border-primary":
                                            "col-6 col-md-4 col-lg-3 px-1 py-2 d-flex align-items-start"}
                                        >
                                        <ResultComponent
                                            checkActive = {checkActive}
                                            result = {result}
                                            setVideoList = {props.setVideoList}
                                            setChosenDuration = {setChosenDuration}
                                            videoList = {props.videoList}
                                        />
                                    </div>

                                ))
                            }
                        </div>

                        </div>
                        <Modal
                            trigger = {addActive}
                            setTrigger = {setAddActive}
                            top = {top}
                            right = {right}
                            content = {
                                <AddVideoToPlaylistContent
                                    setIsActive = {setAddActive}
                                    video_list = {props.videoList}
                                    index = {2}
                                />
                            }
                        />
                </div> :
                    props.loading ?
                <div className = "text-info col-12 col-lg-11" >Loading...</div> :
                    props.message ?
                <div className="text-info col-12 col-lg-11" >
                    {props.message}
                </div> : ""
            }
        </>
    );
}

export default ResultsComponent;